import { useUI } from 'store/UI/selectors';
import { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { updateUI } from 'store/UI/actions';
import { useCurrentUser } from 'store/users/selectors';

const useActiveStudentofParent = () => {
  const currentUser = useCurrentUser();
  const { parentStudents = [], activeStudent = null } = useUI();
  const dispatch = useDispatch();

  const activeStudentData = useMemo(() => {
    try {
      if (activeStudent) {
        return parentStudents.find((student) => student.student_id === activeStudent);
      }
    } catch (error) {
      console.log(error);
    }
  }, [parentStudents, activeStudent]);

  useEffect(() => {
    try {
      if (parentStudents?.length > 0 && !activeStudent && !localStorage.getItem('activeStudent')) {
        handleUpdateActiveStudent(parentStudents[0]?.student_id);
      }else{
        handleUpdateActiveStudent(localStorage.getItem('activeStudent'));
      }
    } catch (error) {
      console.log(error);
    }
  }, [parentStudents, activeStudent]);

  const handleUpdateActiveStudent = (studentId) => {
    localStorage.setItem('activeStudent', studentId);
    dispatch(updateUI({ activeStudent: studentId }));
  };

  return {
    activeStudentParent: activeStudent ? activeStudent : localStorage.getItem('activeStudent') || currentUser?.parent_of,
    activeStudentData,
    handleUpdateActiveStudent,
  };
};

export default useActiveStudentofParent;
